import { damagePlayer } from './player';
import { playRoachDeathSound } from './audio';

// Frame layout (38×18 per frame, 8 frames):
// 0–5: Walk 01–06
// 6–7: Dead 01–02
const FRAMES = { walkStart: 0, walkEnd: 5, deadStart: 6, deadEnd: 7 };

const SPEED = 40;

const CONFIGS = [
  { x: 384, y: 496, patrolLeft: 256, patrolRight: 528 },
  { x: 303, y: 199, patrolLeft: 240, patrolRight: 400 },
];

export function createRoaches(scene) {
  scene.roaches = [];

  scene.anims.create({
    key: 'roachWalk',
    frames: scene.anims.generateFrameNumbers('roach', { start: FRAMES.walkStart, end: FRAMES.walkEnd }),
    frameRate: 10,
    repeat: -1
  });
  scene.anims.create({
    key: 'roachDie',
    frames: scene.anims.generateFrameNumbers('roach', { start: FRAMES.deadStart, end: FRAMES.deadEnd }),
    frameRate: 6,
    repeat: 0
  });

  for (const cfg of CONFIGS) addRoach(scene, cfg);
}

function addRoach(scene, cfg) {
  const roach = scene.physics.add.sprite(cfg.x, cfg.y, 'roach', FRAMES.walkStart);
  roach.setScale(1);
  roach.setBounce(0);
  roach.setCollideWorldBounds(true);
  roach.body.setSize(30, 12);
  roach.body.setOffset(4, 6);
  roach.setDepth(5);

  roach.health          = 2;
  roach.isDying         = false;
  roach.requiresCrouch  = true;
  roach.patrolLeft  = cfg.patrolLeft;
  roach.patrolRight = cfg.patrolRight;
  roach.direction   = 1; // start moving right

  roach.hit = (_facing) => hitRoach(scene, roach);

  roach.anims.play('roachWalk');
  roach.flipX = false;

  scene.physics.add.collider(roach, scene.environmentLayer);

  scene.physics.add.overlap(scene.player, roach, () => {
    if (roach.isDying) return;
    const alreadyInvincible = scene.playerInvincible;
    damagePlayer(scene, 0.5);
    if (scene.player.isDead) return;
    if (alreadyInvincible) return;
    if (scene.player.isClimbing || scene.player.isPerched) return;
    const knockDir = scene.player.x < roach.x ? -1 : 1;
    scene.player.setVelocityX(knockDir * 180);
    scene.player.knockbackTimer = 300;
  }, null, scene);

  scene.roaches.push(roach);
}

function hitRoach(scene, roach) {
  if (roach.isDying) return;
  roach.health -= 1;
  scene.tweens.add({
    targets: roach,
    alpha: 0.2,
    duration: 60,
    yoyo: true,
    repeat: 3,
    onComplete: () => roach?.active && roach.setAlpha(1)
  });
  if (roach.health <= 0) killRoach(scene, roach);
}

function killRoach(scene, roach) {
  roach.isDying = true;
  roach.setVelocity(0, 0);
  roach.body.setAllowGravity(false);
  roach.body.setImmovable(true);
  playRoachDeathSound();
  roach.anims.play('roachDie');
  roach.once('animationcomplete-roachDie', () => {
    scene.time.delayedCall(400, () => roach?.destroy());
  });
}

export function updateRoaches(scene) {
  for (const roach of scene.roaches) {
    if (!roach.active || roach.isDying) continue;

    // Flip at patrol bounds or on wall collision
    if (roach.x <= roach.patrolLeft || roach.body.blocked.left) {
      roach.direction = 1;
    } else if (roach.x >= roach.patrolRight || roach.body.blocked.right) {
      roach.direction = -1;
    }

    roach.setVelocityX(roach.direction * SPEED);
    roach.flipX = roach.direction > 0;
  }

  scene.roaches = scene.roaches.filter(r => r.active);
}
